/**
 * FontStylePicker — wybór stylu typografii generowanej strony (2 opcje).
 * Zmienia charakter całej strony hodowcy (nagłówki + tekst).
 */
import { Check } from 'lucide-react';

const OPTIONS = [
  { id: 'elegant', label: 'Elegancki', desc: 'Dostojne, klasyczne', headFont: "'Cormorant Garamond', Georgia, serif", bodyFont: "'Manrope', sans-serif" },
  { id: 'modern', label: 'Nowoczesny', desc: 'Mocne, geometryczne', headFont: "'Space Grotesk', system-ui, sans-serif", bodyFont: "'Inter', sans-serif" },
];

export default function FontStylePicker({ value = 'elegant', onChange }) {
  const active = value || 'elegant';
  return (
    <div data-testid="font-style-picker" className="rounded-2xl border border-gray-200 bg-white p-5">
      <div className="mb-3">
        <p className="text-sm font-semibold text-gray-900">Styl typografii strony</p>
        <p className="text-xs text-gray-500 mt-0.5">Wybierz charakter pisma — zmienia wygląd całej Twojej strony.</p>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {OPTIONS.map((o) => {
          const isActive = active === o.id;
          return (
            <button
              key={o.id}
              type="button"
              data-testid={`font-style-${o.id}`}
              onClick={() => onChange?.(o.id)}
              className={`relative text-left rounded-xl border-2 p-4 transition-all ${isActive ? 'border-amber-500 bg-amber-50/50 ring-2 ring-amber-500/20' : 'border-gray-200 hover:border-gray-300 bg-white'}`}
            >
              {isActive && (
                <span className="absolute top-2 right-2 w-5 h-5 rounded-full bg-amber-500 flex items-center justify-center">
                  <Check className="w-3 h-3 text-white" />
                </span>
              )}
              <div style={{ fontFamily: o.headFont }} className="text-3xl leading-none text-gray-900">Aa</div>
              <div style={{ fontFamily: o.bodyFont }} className="mt-2 text-[13px] font-semibold text-gray-900">{o.label}</div>
              <div style={{ fontFamily: o.bodyFont }} className="text-[11px] text-gray-500">{o.desc}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
